import { __css, mergeClasses, tokens } from '@fluentui/react-components';
import { createLink } from '@tanstack/react-router';
import { forwardRef, type AnchorHTMLAttributes } from 'react';

const useStyles = __css({"link":{"sj55zd":"fyind8e","w71qe1":"f1iuv45f","Bceei9c":"f1k6fduh","Bi91k9c":"f1deo86v","Bde5pd6":"f1tx3yz7","Beohmeb":"f1u5sdlw","B486eqv":"f1u8i3ug","vu0emg":"fvi4nxw","Bpw7sjs":0,"zppij7":0,"ajd3u1":0,"iqhfy":0,"B7b6voy":"f7k1yb4"},"inline":{"w71qe1":"f13mvf36"}});

type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  /** The link sits inside a sentence (underlined). */
  inline?: boolean;
};

const StyledAnchor = forwardRef<HTMLAnchorElement, AnchorProps>(function StyledAnchor(
  { className, inline = false, ...rest },
  ref,
) {
  const styles = useStyles();
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content -- the content is passed in `rest`
    <a
      ref={ref}
      className={mergeClasses(styles.link, inline && styles.inline, className)}
      {...rest}
    />
  );
});

/**
 * A text link in the Fluent link style that navigates inside the app through the typed router:
 * `to` and `params` are checked against the route tree, and the `href` stays a real address
 * (middle click and "open in a new tab" keep working).
 */
export const AppLink = createLink(StyledAnchor);


import "/opt/batiflow/app/apps/web/src/shared/components/app-link.griffel.css";